import React from "react";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";

class Input extends React.Component {
  render() {
    const {
      inputType,
      inputLabel,
      inputValue,
      inputOnChange,
      inputErrorText,
      inputVariant
    } = this.props;

    return (
      <FormControl margin="normal" fullWidth>
        <TextField
          className="textfield"
          type={inputType}
          label={inputLabel}
          value={inputValue}
          onChange={inputOnChange}
          helperText={inputErrorText}
          variant={inputVariant}
        />
      </FormControl>
    );
  }
}

Input.propTypes = {
  classes: PropTypes.object.isRequired
};

export default Input;



// WEBPACK FOOTER //
// ./src/Controls/Input.js